
import menuUploadGridItemAddPhoto from "./menu-upload-grid-item-add-photo.vue";
import menuUploadGridItemDescription from "./menu-upload-grid-item-description.vue";
import menuUploadGridItemSetAddons from "./menu-upload-grid-item-set-addons.vue";
import MenuUploadGridItemSetChoices from "./menu-upload-grid-item-set-choices.vue";
export default {
  components: {
    menuUploadGridItemAddPhoto,
    menuUploadGridItemDescription,
    menuUploadGridItemSetAddons,
    MenuUploadGridItemSetChoices
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },

  methods: {}
};
